let moduleSlideshowSwiper = new Swiper('.module-slideshow .swiper-container', {
	slidesPerView: 'auto',
	spaceBetween: 0,
	navigation:    {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: ".swiper-pagination",
	},
	breakpoints: {
		768: {
			slidesPerView: 3,
			spaceBetween: 12
		},
		992: {
			slidesPerView: 3,
			spaceBetween: 24
		},
		1440: {
			slidesPerView: 3,
			spaceBetween: 51
		}
	},
	watchOverflow: true, // disable swiper if there's only one slide
	on: {
		lock: function (swiper) {
			swiper.el.classList.add('disabled');
		}
	}
});